import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import BackgroundTimeZone from '../../../domain/entities/BackgroundTimeZone';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexBackgroundTimeZonesSuccess: {
      const result = action.payload as PaginatedResult<BackgroundTimeZone>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
